export default class KitModule {
  constructor($element) {
    this.$element = $element;
    this.updateChildren();
  }

  updateChildren() {
    // map child elements to their data-js-child key
    // data-js-child="$button" -> this.$button = <button>
    const $childElements = this.getChildElements('[data-js-child]');
    $childElements.forEach(($child) => {
      const key = $child.getAttribute('data-js-child');
      this[key] = $child;
    });

    // map children elements to their data-js-children key
    // data-js-children="$item" -> this.$items = [ <li>, <li>, <li> ]
    const $childrenElements = this.getChildElements('[data-js-children]');
    $childrenElements.forEach(($child) => {
      const key = $child.getAttribute('data-js-children');
      if (!this[key]) this[key] = []; // create array if first child
      this[key].push($child);
    });
  }

  /**
   * @param {String} selector
   * @return {Array} childElements
   */
  getChildElements(selector) {
    const $childElements = this.$element.querySelectorAll(selector);
    // filter out child elements of child modules
    return [...$childElements].filter(($child) => {
      return this.$element === $child.closest('[data-js-module]');
    });
  }

  // enable $element.addEventListener('eventname', this)
  // to trigger oneventname() method
  handleEvent(event) {
    const method = `on${event.type}`;
    if (this[method]) this[method](event);
  }

  unmount() {}
}

// add to global namespace
window.KitModule = KitModule;
